import { BannerConfig } from "./BannerConfig";
import { BannerCTA } from "./BannerCTA";
import { BannerData } from "./BannerData";

export class Banner {
  constructor(data) {
    this.data = data;
  }

  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new Banner(input)
    }

    return new Banner();
  }

  static fromApiArray(input) {
    if (input && Array.isArray(input)) {
      return input.map(item => Banner.fromApiObject(item));
    }

    if (input && typeof (input) === "object") {
      return [Banner.fromApiObject(input)];
    }

    return [];
  }

  /**
   * 
   * @returns {[BannerCTA, Object]}
   */
  getActiveBanners(isBannerCTA = true) {
    BannerData.fromApiArray()
    /** @type {BannerCTA} */
    let result = [];
    /** @type {[BannerConfig]} */
    let configs = [], path = window.location.pathname;;

    if (Object.keys(this.data).length) {
      Object.keys(this.data).forEach(key => {
        console.log({ d: key })
        let config = BannerConfig.fromApiObject(key);
        if (config.isValidConfig()) {
          let dupConfig = configs.filter(item => item.slug && (
            (typeof (item.slug) === "string" && item.slug === path) || (Array.isArray(item.slug) && item.slug.includes(path))
          ))
          if (!dupConfig.length) {
            dupConfig = configs.filter(item =>
              (item.device === config.device || !config.device) &&
              (item.language === config.language || !config.language) &&
              (item.delivery === config.delivery || !config.delivery) &&
              (item.currency === config.currency || !config.currency) &&
              (item.tier === config.tier || !config.tier) &&
              (item.platform === config.platform || !config.platform) &&
              (item.startTime === config.startTime || !config.startTime) &&
              (item.endTime === config.endTime || !config.endTime)
            )
            if (!dupConfig.length) {
              configs.push(config)
              let data = this.data[key];
              if (data) {
                if (isBannerCTA) {
                  data = BannerCTA.fromApiArray(data);
                }
                if (typeof (data) === "string") {
                  result.push(data);
                }
                if (Array.isArray(data)) {
                  result.push(...data);
                }
              }
            }
          }
        }
      });
    }
    console.log({ d: result })
    return result;
  }
}